import {Checkbox} from "@mui/material";
import React from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../../../stores";

export const RootSelectionBox: React.FC = observer(() => {
    const {categorizationReviewStore} = useStores()
    const selectionController = categorizationReviewStore.reviewPageController.reviewPageSelectionController;
    const {checked, indeterminate} = selectionController.rootSelectionState;

    return <Checkbox
        className="root-selection-component"
        checked={checked}
        indeterminate={indeterminate}
        onClick={() => selectionController.toggleSelectAll()}

        // While a single row is loading it's not selectable, while this button will select everything.
        //  to avoid an inconsistent state this component is disabled while rows are not-selectable
        disabled={categorizationReviewStore.reviewPageController.isLoadingData}
    />
})
